export default () => <div style={{ flex: 1 }} />;
